module.exports = __webpack_public_path__ + "static/media/bcsgQAScreen1.c3cb94b4.jpg";